import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { TextHighlight } from "./text-highlight";
import '@isyc-react/design/main';
import "./view-plain-text.style.scss";
export const ViewChunkPlainText = props => {
  const {
    text,
    chunkSize = 50000,
    highlight = {
      enabled: true
    }
  } = props;
  const [chunks, setChunks] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const chunkString = React.useCallback((string, chunkSize) => {
    const results = [];
    let chunkIndex = 0;
    while (chunkIndex < string.length) {
      results.push(string.substring(chunkIndex, chunkIndex += chunkSize));
    }
    return results;
  }, []);
  React.useEffect(() => {
    setChunks(chunkString(text, chunkSize));
  }, [text]);
  React.useEffect(() => {
    setLoading(false);
  }, []);

  // console.log('TEXT LENGHT: ', text.length)
  // TODO optimize more than chunks, just render on scroll chunks??

  return /*#__PURE__*/React.createElement("div", {
    className: "view-chunk-plain-text"
  }, loading && /*#__PURE__*/React.createElement("div", {
    className: "view-text-document-spinner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner-border text-primary",
    role: "status"
  })), highlight.enabled ? /*#__PURE__*/React.createElement(TextHighlight, {
    languages: highlight.languages
  }, chunks.map((chunk, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, chunk))) : /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, chunks.map((chunk, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, chunk)))));
};